import { SeoLink } from '@/lib/generated/graphql-types'
import { SalaryFilterControl } from '../constants'
import {
  getJobTypeSalaryFiltersFromUrl,
  getStateSalaryFiltersFromUrl,
} from '../filters/filter-utils'
import { UseSalaryFiltersProps } from '../filters/use-salary-filters'

export function handleSeoLinkClick({
  evt,
  link,
  updateSalaryFilters,
}: {
  evt: React.MouseEvent<HTMLAnchorElement>
  link: SeoLink
  updateSalaryFilters: UseSalaryFiltersProps['updateSalaryFilters']
}) {
  evt.preventDefault()
  const profession = link.occupation?.profession?.slug ?? link.profession?.slug
  const specialty = link.occupation?.specialty?.slug

  updateSalaryFilters({
    [SalaryFilterControl.jobType]: getJobTypeSalaryFiltersFromUrl(link.jobType),
    [SalaryFilterControl.state]:
      getStateSalaryFiltersFromUrl({
        location: link.state?.slug,
      }) ?? null,
    [SalaryFilterControl.profession]: profession,
    [SalaryFilterControl.specialty]: specialty,
  })
}
